/**
 * Phase 0 placeholder screen — proves routing + Tailwind + health connectivity.
 *
 * Calls the public /system/health endpoint to confirm the web app can reach the API
 * through the dev proxy. Replaced by real role screens in later phases.
 */

import { useQuery } from "@tanstack/react-query";

import { getHealth } from "../api/system";
import { isInWebView } from "../bridge/webview";
import { Logo } from "./Logo";

export function Placeholder({
  title,
  surface,
}: {
  title: string;
  surface: string;
}) {
  const { data, isError } = useQuery({
    queryKey: ["health"],
    queryFn: getHealth,
  });

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-sunken px-4 text-ink">
      <Logo variant="stacked" size={60} withTagline className="mb-2" />
      <h1 className="page-title">{title}</h1>
      <p className="text-sm text-ink-muted">surface: {surface}</p>
      <div className="card px-4 py-2 text-sm">
        API health:{" "}
        {isError ? (
          <span className="font-medium text-danger">unreachable</span>
        ) : (
          <span className="font-medium text-success">{data?.status ?? "…"}</span>
        )}
      </div>
      <p className="text-xs text-ink-faint">
        {isInWebView() ? "running in WebView" : "running in browser"}
      </p>
    </main>
  );
}
